import uuid from 'uuid';

const getUniqueId = (base = '') => {
    const longUUId = uuid();
    const shortUUId = longUUId.split('-')[0];
    return base ? `${base.replace(/\s+/g, '-').toLowerCase()}_${shortUUId}` : longUUId;
};

export default getUniqueId;



// WEBPACK FOOTER //
// ./src/client/utils/getUniqueId.js